export default __webpack_public_path__ + "static/media/BG_Page_04.fc28ff80.svg";